import { render, staticRenderFns } from "./Rs.vue?vue&type=template&id=0d048c50&scoped=true"
import script from "./Rs.vue?vue&type=script&lang=js"
export * from "./Rs.vue?vue&type=script&lang=js"
import style0 from "./Rs.vue?vue&type=style&index=0&id=0d048c50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d048c50",
  null
  
)

export default component.exports